/* eslint-disable sort-keys-fix/sort-keys-fix */

const breakpoints = {
  sm: '30em', // 480px
  md: '48em', // 768px
  lg: '62em', // 992px
  xl: '80em', // 1280px
  '2xl': '90em', // 1440px
  '3xl': '120em', // 1920px
  '4xl': '144em', // 2304px
};

export default breakpoints;
